import { render, staticRenderFns } from "./WindowProperties.vue?vue&type=template&id=3f9ce626&scoped=true&"
import script from "./WindowProperties.vue?vue&type=script&lang=ts&"
export * from "./WindowProperties.vue?vue&type=script&lang=ts&"
import style0 from "./WindowProperties.vue?vue&type=style&index=0&id=3f9ce626&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9ce626",
  null
  
)

export default component.exports